var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from 'react';
import { Button, Input, FormGroup, Label } from 'reactstrap';
// import Sortable from 'react-sortablejs'
import { v4 as uuidv4 } from 'uuid';
import LocationPickerModal from './LocationPickerModal';
// const SortableComponent = Sortable as unknown as React.FC<any>
var defaultLat = 36.7213; // Málaga
var defaultLng = -4.4214;
var MultiLocationPicker = function (_a) {
    var _b;
    var points = _a.points, onChange = _a.onChange, typeOptions = _a.typeOptions;
    var _c = useState(null), editingPoint = _c[0], setEditingPoint = _c[1];
    var _d = useState(false), modalOpen = _d[0], setModalOpen = _d[1];
    var _e = useState(((_b = typeOptions[0]) === null || _b === void 0 ? void 0 : _b.value) || ''), selectedType = _e[0], setSelectedType = _e[1];
    var toggleModal = function () { return setModalOpen(!modalOpen); };
    var handleAdd = function () {
        var newPoint = {
            id: uuidv4(),
            lat: defaultLat,
            lng: defaultLng,
            address: '',
            type: selectedType || typeOptions[0].value,
        };
        setEditingPoint(newPoint);
        setModalOpen(true);
    };
    var handleEdit = function (point) {
        setEditingPoint(point);
        setModalOpen(true);
    };
    var handleDelete = function (index) {
        var updated = __spreadArray([], points, true);
        updated.splice(index, 1);
        onChange(updated);
    };
    var handleSave = function (updatedPoint) {
        // console.log('updatedPoint: ', updatedPoint)
        if (!editingPoint)
            return;
        var updatedPoints = __spreadArray([], points, true);
        var index = updatedPoints.findIndex(function (p) { return p.id === editingPoint.id; });
        if (index === -1) {
            // nuevo punto (al añadir)
            updatedPoints.push(__assign(__assign({}, updatedPoint), { id: uuidv4(), pointType: selectedType }));
        }
        else {
            // edito punto existente
            updatedPoints[index] = __assign(__assign({}, updatedPoint), { id: editingPoint.id });
            console.log('updatedPoint: ', updatedPoints[index]);
        }
        onChange(updatedPoints);
        setEditingPoint(null);
        setModalOpen(false);
    };
    var handleTypeChange = function (index, newType) {
        var updated = __spreadArray([], points, true);
        updated[index].pointType = newType;
        onChange(updated);
    };
    /*useEffect(() => {
      const el = document.getElementById('sortable-list')
      if (!el) return
      const sortable = Sortable.create(el, {
        animation: 150,
        onEnd: (evt) => {
          const newOrder = [...points]
          const [movedItem] = newOrder.splice(evt.oldIndex!, 1)
          newOrder.splice(evt.newIndex!, 0, movedItem)
          onChange(newOrder)
        },
      })
      return () => {
        sortable.destroy()
      }
    }, [points, onChange])*/
    return (React.createElement("div", null,
        React.createElement(FormGroup, null,
            React.createElement(Label, { for: "select-type" }, "Tipo del nuevo punto"),
            React.createElement(Input, { type: "select", id: "select-type", value: selectedType, onChange: function (e) { return setSelectedType(e.target.value); } }, typeOptions.map(function (opt) { return (React.createElement("option", { key: opt.value, value: opt.value }, opt.label)); }))),
        React.createElement(Button, { color: "primary", onClick: handleAdd, className: "mb-3" }, "A\u00F1adir punto"),
        React.createElement("ul", { className: "list-unstyled" }, points.map(function (point, index) { return (React.createElement("li", { key: point.id, className: "mb-2 p-2 border rounded d-flex align-items-center justify-content-between" },
            React.createElement(FormGroup, { style: { flex: '1 1 auto', marginBottom: 0 } },
                React.createElement(Label, { for: "type-select-".concat(point.id) }, "Tipo"),
                React.createElement(Input, { type: "select", id: "type-select-".concat(point.id), value: point.pointType, onChange: function (e) { return handleTypeChange(index, e.target.value); } }, typeOptions.map(function (opt) { return (React.createElement("option", { key: opt.value, value: opt.value }, opt.label)); })),
                React.createElement("div", null,
                    React.createElement("strong", null, point.address || point.displayName || 'Sin dirección'))),
            React.createElement("div", { className: "ml-3 d-flex flex-column" },
                React.createElement(Button, { color: "secondary", size: "sm", onClick: function () { return handleEdit(point); }, className: "mb-1" }, "Editar"),
                React.createElement(Button, { color: "danger", size: "sm", onClick: function () { return handleDelete(index); } }, "Eliminar")))); })),
        editingPoint && (React.createElement(LocationPickerModal, { isOpen: modalOpen, toggle: toggleModal, point: editingPoint, onSave: handleSave }))));
};
export default MultiLocationPicker;



//////////////////
// WEBPACK FOOTER
// ./src/components/LocationPicker/AdvancedLocationPicker/MultiLocationPicker.tsx
// module id = 1520
// module chunks = 0